import React from 'react';
import './Article.css';

const Article2 = () => {
  return (
    <div className="article-container">
      <h2>2024/05/10 長井先生の誕生日パーティーを開催しました!🎉</h2>
      <p>ケーキを買ってみんなでお祝いしました！</p>


      <div className="article-images">
        <div className="article-image horizontal">
          <img src="/images/Article2_1.jpg" alt="Birthday Image 1" />
        </div>

      </div>
    </div>
  );
}

export default Article2;
